// extracted by mini-css-extract-plugin
export default {"rightMargin":"GroupAnimalsList_rightMargin__7HrVw"};